import Grid from '@material-ui/core/Grid'
import React, { FC } from 'react'
import { CustomerStoryBodyContent, CustomerStoryBodyOuter, SideBarItem } from './style'

//* utils
import { ModuleNames } from '../../../../constants/componentNames.constants'
import { MicrocopyTitles } from '../../../../constants/microcopy.constants'
import { RichTextWrapper } from '../../../../styles/global'
import ImgUtil from '../../../../utils/img.utils'
import { getMicrocopyWithoutNumber } from '../../../../utils/microcopy.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'

//* components
import Typography from '../../../global/typography'
import WrapperImage from '../../../global/wrapperImage'

type Props = {
  caseStudyData: any
}

export const RenderPageBody: FC<Props> = ({ caseStudyData }) => {
  const sideBar: any = []
  const microcopy = caseStudyData.customerStoryMicrocopy
  const body = caseStudyData.body ? (
    <CustomerStoryBodyContent>{renderRichText(caseStudyData.body)}</CustomerStoryBodyContent>
  ) : null

  caseStudyData.metaInformation.map((topic: any, i: number) => {
    const topicData: any = {
      type: '',
      element: '',
      elementBody: null,
      image: {
        url: topic.colorLogo?.image?.file?.url || '',
        alt: topic.colorLogo?.altText || 'UiPath partner logo',
      },
      eyebrow: [],
      body: '',
      __typename: topic.__typename,
    }

    if (topicData.__typename === ModuleNames.TOPIC_CUSTOMER_DETAILS) {
      topicData.type = MicrocopyTitles.CLIENT
      topicData.element = MicrocopyTitles.OVERVIEW_TEXT

      if (topic.overview) {
        topicData.elementBody = (
          <RichTextWrapper $type="bodyXS" className="SideBar__Item-Body font__inter">
            {renderRichText(topic.overview)}
          </RichTextWrapper>
        )
      }
    }

    if (topicData.__typename === ModuleNames.TOPIC_PARTNER_DETAILS) {
      topicData.type = MicrocopyTitles.PARTNER
      topicData.element = MicrocopyTitles.LOGO_TEXT

      if (topicData.image.url) {
        topicData.elementBody = (
          <div className="SideBar__Item-Logo">
            <WrapperImage
              src={ImgUtil.getResizedImageUrl(topicData.image.url, `width=450`)}
              className="SideBar__Item-Logo-File"
              alt={topicData.image.alt}
              width={280}
              height={140}
              threshold={650}
            />
          </div>
        )
      }
    }

    if (topicData.type && microcopy) {
      topicData.eyebrow = getMicrocopyWithoutNumber(microcopy, topicData.type, topicData.element)
    }

    if (topicData.eyebrow[0]?.value) {
      sideBar.push(
        <SideBarItem key={`SideBarItem--${i}`}>
          <Typography type="captionAlt" className="SideBar__Item-Title">
            {topicData.eyebrow[0].value}
          </Typography>

          {topicData.elementBody}
        </SideBarItem>
      )
    }
  })

  return (
    <CustomerStoryBodyOuter>
      <Grid container={true} spacing={2} direction="row" className="CustomerStory__Body-Container">
        <Grid item={true} md={3} xs={12} className="CustomerStory__SideBar-Grid-Item">
          {sideBar && <div className="SideBar">{sideBar}</div>}
        </Grid>

        <Grid item={true} md={6} xs={12} className="CustomerStory__Body-Grid-Item">
          {body}
        </Grid>
      </Grid>
    </CustomerStoryBodyOuter>
  )
}
